import { t } from "@bookingcom/lingojs-core";
import { I18nChildContext } from "@bookingcom/lingojs-react";
import flights_web_budget_layover_airports_filters from "../utils/experiments/funnel/flights_web_budget_layover_airports_filters";

export type FilterKey =
  | "NUMBER_OF_STOPS"
  | "DURATION"
  | "JOURNEY_TIME_FILTER"
  | "AIRLINES"
  | "FLIGHT_TIMES_FILTER"
  | "LAYOVER_CONNECTION"
  | "MAX_BUDGET"
  | "MAX_BUDGET_PER_ADULT"
  | "INCLUDED_BAGGAGE"
  | "LAYOVER_DURATION"
  | "AIRPORTS_FILTER"
  | "PREFER_SAME_AIRPORT"
  | "ALL_DEALS";

export type StoreKeys =
  | "stops"
  | "multiSelectStops"
  | "duration"
  | "departureIntervals"
  | "arrivalIntervals"
  | "airlines"
  | "flightTimes"
  | "shortLayoverConnection"
  | "maxBudget"
  | "maxBudgetPerAdult"
  | "includedBaggage"
  | "maxLayoverDuration"
  | "airports"
  | "sameAirport"
  | "flexibility";

export interface FilterMeta {
  copy: string;
  storeKeys: StoreKeys[];
}

export interface FiltersMeta {
  [key: string]: FilterMeta;
}

export const flexibilityFilterOptions = ["flexibleTicket"] as const;
export type FlexibilityFilterOption = typeof flexibilityFilterOptions[number];

export const getFiltersMeta = (i18n: I18nChildContext): FiltersMeta => ({
  NUMBER_OF_STOPS: {
    copy: i18n.trans(t("flights_filter_stops")),
    storeKeys: ["stops", "multiSelectStops"]
  },
  DURATION: {
    copy: !!flights_web_budget_layover_airports_filters.trackWithDefaultStage()
      ? i18n.trans(t("flights_filters_duration_title"))
      : i18n.trans(t("flights_filter_duration")),
    storeKeys: ["duration"]
  },
  JOURNEY_TIME_FILTER: {
    copy: i18n.trans(t("flights_filter_flight_time")),
    storeKeys: ["departureIntervals", "arrivalIntervals"]
  },
  AIRLINES: {
    copy: i18n.trans(t("flights_filter_airlines")),
    storeKeys: ["airlines"]
  },
  FLIGHT_TIMES_FILTER: {
    copy: i18n.trans(t("flights_filters_times_title")),
    storeKeys: ["flightTimes"]
  },
  LAYOVER_CONNECTION: {
    copy: i18n.trans(t("flights_filters_duration_layover")),
    storeKeys: ["shortLayoverConnection"]
  },
  MAX_BUDGET: {
    copy: i18n.trans(t("flights_filters_budget_title")),
    storeKeys: ["maxBudget"]
  },
  MAX_BUDGET_PER_ADULT: {
    copy: i18n.trans(t("flights_filter_price_title")),
    storeKeys: ["maxBudgetPerAdult"]
  },
  INCLUDED_BAGGAGE: {
    copy: i18n.trans(t("flights_filters_baggage_title")),
    storeKeys: ["includedBaggage"]
  },
  LAYOVER_DURATION: {
    copy: i18n.trans(t("flights_filters_duration_layover")),
    storeKeys: ["maxLayoverDuration"]
  },
  AIRPORTS_FILTER: {
    copy: i18n.trans(t("flights_filters_airports_title")),
    storeKeys: ["airports"]
  },
  PREFER_SAME_AIRPORT: {
    copy: i18n.trans(t("flights_filters_same_airport_title")),
    storeKeys: ["sameAirport"]
  },
  ALL_DEALS: {
    copy: i18n.trans(t("flights_filters_deals_title")),
    storeKeys: []
  },
  FLEXIBILITY: {
    copy: i18n.trans(t("flights_filters_flexibility_title")),
    storeKeys: ["flexibility"]
  }
});
